import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import TopBar from "@/components/site/TopBar";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import CartDrawer from "@/components/site/CartDrawer";

const PolicyPage = ({ eyebrow, title, updated, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#0b0b0c] text-[#f4ead5]">
      <TopBar />
      <Header />

      <section className="relative overflow-hidden bg-[#0b0b0c] border-b border-[#1c1c1e]">
        <div
          className="absolute inset-0 opacity-[0.25]"
          style={{
            backgroundImage:
              "radial-gradient(900px 400px at 80% 20%, rgba(201,162,74,0.3), transparent 60%)",
          }}
        />
        <div className="relative max-w-[900px] mx-auto px-6 lg:px-10 pt-14 pb-16">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-[#a9a294] hover:text-[#c9a24a] text-xs uppercase tracking-[0.25em] mb-8 transition-colors"
          >
            <ArrowLeft size={14} />
            Back to home
          </Link>
          {eyebrow && (
            <div className="text-[#c9a24a] uppercase text-[11px] tracking-[0.4em] mb-4">
              {eyebrow}
            </div>
          )}
          <h1 className="font-serif text-[#f4ead5] text-4xl md:text-5xl leading-tight">
            {title}
          </h1>
          {updated && (
            <div className="mt-4 text-[#a9a294] text-xs uppercase tracking-[0.2em]">
              Last updated: {updated}
            </div>
          )}
        </div>
      </section>

      <section className="bg-[#0b0b0c] py-16">
        <div className="max-w-[900px] mx-auto px-6 lg:px-10 policy-content">
          {children}
        </div>
      </section>

      <Footer />
      <CartDrawer />

      <style>{`
        .policy-content h2 {
          font-family: 'Cormorant Garamond', Georgia, serif;
          color: #f4ead5;
          font-size: 1.75rem;
          margin-top: 2.5rem;
          margin-bottom: 1rem;
          letter-spacing: -0.01em;
        }
        .policy-content h2:first-child { margin-top: 0; }
        .policy-content h3 {
          font-family: 'Cormorant Garamond', Georgia, serif;
          color: #e9d9b0;
          font-size: 1.25rem;
          margin-top: 1.75rem;
          margin-bottom: 0.75rem;
        }
        .policy-content p {
          color: #c4bba6;
          font-size: 15px;
          line-height: 1.75;
          margin-bottom: 1rem;
        }
        .policy-content ul {
          color: #c4bba6;
          font-size: 15px;
          line-height: 1.8;
          margin-bottom: 1rem;
          padding-left: 1.25rem;
          list-style: none;
        }
        .policy-content ul li {
          position: relative;
          padding-left: 1rem;
          margin-bottom: 0.4rem;
        }
        .policy-content ul li::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0.75rem;
          width: 4px;
          height: 4px;
          background: #c9a24a;
          border-radius: 50%;
        }
        .policy-content strong { color: #f4ead5; font-weight: 500; }
        .policy-content a { color: #c9a24a; text-decoration: underline; text-underline-offset: 3px; }
        .policy-content a:hover { color: #e9d9b0; }
      `}</style>
    </div>
  );
};

export default PolicyPage;
